export const MODAL_TEST_IDS = {
  MODAL_TEST_CONTAINER     : 'modal-test-container',
  MODAL_TEST_CLOSE_ICON    : 'modal-test-close-icon',
  MODAL_TEST_CANCEL_BUTTON : 'modal-test-cancel-button',
  MODAL_TEST_CONFIRM_BUTTON: 'modal-test-confirm-button'
};
